import { SelectionControl } from '../../../../design_system/components/SelectionControls/SelectionControl.jsx'
import { Icons } from '../../../../design_system/components/Icons'

const ControlRow = ({ label, description, action, className = '' }) => {
    const descriptionClass = className === 'controls-source-card__setting' ? 'body-s' : 'body-s-semibold'

    return (
        <div className={`settings-panel__item${className ? ` ${className}` : ''}`}>
            <div className="settings-panel__item-info">
                <span className="body-m-semibold settings-panel__item-title">{label}</span>
                {description && <span className={`${descriptionClass} settings-panel__item-desc`}>{description}</span>}
            </div>
            {action && <div className="settings-panel__item-action">{action}</div>}
        </div>
    )
}

export const ControlToggleRow = ({ label, description, checked, onToggleClick, disabled, nested }) => (
    <ControlRow
        label={label}
        description={description}
        className={nested ? 'controls-sub-setting--nested' : ''}
        action={( <SelectionControl type="toggle" checked={checked} onChange={onToggleClick} disabled={disabled} /> )}
    />
)

const SOURCE_ICON_NAMES = {
    news: 'newsfeed',
    jobs: 'job-updates',
    sec: 'sec-filings',
}

export const ControlSourceCard = ({ source, label, description, checked, disabled, statusLabel, statusVariant, onToggleClick, children }) => (
    <div className="controls-source-card">
        <div className="controls-source-card__head">
            <Icons name={SOURCE_ICON_NAMES[source]} size={36} />
            <div className="controls-source-card__text">
                <div className="controls-source-card__title-row">
                    <span className="body-m-semibold color-text-primary">{label}</span>
                    <span className={`support-m-semibold controls-source-card__status${statusVariant || !checked ? ` controls-source-card__status--${statusVariant || 'off'}` : ''}`}>
                        <span className="controls-source-card__status-dot" />
                        {statusLabel || (checked ? 'On' : 'Off')}
                    </span>
                </div>
                <span className="support-l color-text-secondary">{description}</span>
            </div>
            <SelectionControl type="toggle" checked={checked} onChange={onToggleClick} disabled={disabled} />
        </div>
        {children && <div className="controls-source-card__settings">{children}</div>}
    </div>
)

export const ControlSettingRow = ({ label, description, checked, onToggleClick, disabled, children }) => {
    const action = children ?? (onToggleClick ? (
        <SelectionControl type="toggle" checked={checked} onChange={onToggleClick} disabled={disabled} />
    ) : null)

    return <ControlRow label={label} description={description} className="controls-source-card__setting" action={action} />
}
